export class ExperimentVideo{
  constructor(videoSrc,heading, transcript) {
    this.videoSrc = videoSrc;
    this.heading = heading;
    this.transcript = transcript;
  }
}